/*eslint-disable react-hooks/exhaustive-deps*/

import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Grid, Section, Typography, Loading } from "../../core";
import { Avatar } from "antd";
import { MixStyle, media, theme } from "../../styles";
import { updateCurrentPath } from "../../redux/Action/pageRoot";
import styled from "styled-components";
import { UserOutlined, FormOutlined } from "@ant-design/icons";
import BackgroundImage from "../../assets/images/buyer-inner-bg.png";
import BuyerPayments from "../../components/BuyerPayments";

import Statistic from "./Statistic";

import EditBuyerModal from "../../components/Modals/Buyer/EditBuyerModal";

import { getSpecificBuyer } from "../../helper/utils/api/buyer";
const { colors, fontSizes } = theme;

const typoProps = {
  as: "h5",
  weight: "500",
  color: " #404E67",
};

const Conrainer = styled.div`
  height: 89px;
  position: relative;
  ${MixStyle.flexCenter}
  margin-top:100px;
`;

const AvatarWraper = styled.div`
  position: absolute;
  top: -60px;
`;

const Wraper = styled.div`
  padding: 20px 50px;
  .edit--icon_wraper {
    text-align: right;
    ${media.tablet`margin:auto;text-align:center;`}
    font-size: ${fontSizes.textSize6};
    letter-spacing: 0.2px;
    color: ${colors.Fiord};
    svg {
      width: 20.12px;
      height: 20.12px;
      color: ${colors.Fiord};
      margin: 0px 5px;
    }
  }
`;

const BuyerInner = () => {
  const dispatch = useDispatch();
  let location = useLocation();
  let buyerId = location.state._id;

  const [isLoading, setIsLoading] = useState(false);

  const [modalState, setModalState] = useState({
    editBuyerModal: false,
  });

  const [buyer, setBuyer] = useState({
    buyerName: "",
    companyName: "",
    NTN: "",
    STRN: "",
    phoneNumber: "",
    companyAddress: "",
    GodownAddress: [],
    departmentInfo: [],
  });

  useEffect(() => {
    dispatch(updateCurrentPath("Buyer", "Buyer list"));
    getBuyerWithBuyerId();
  }, []);

  const getBuyerWithBuyerId = async () => {
    setIsLoading(true);
    try {
      let {
        data: { result },
      } = await getSpecificBuyer(buyerId);

      setBuyer(result[0]);

      console.log("response", result);
    } catch (error) {
      console.log("error=>", error);
    }
    setIsLoading(false);
  };

  const openModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const closeModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <Conrainer
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <AvatarWraper>
          <Avatar
            size={130}
            icon={<UserOutlined />}
            src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
          />
        </AvatarWraper>
      </Conrainer>
      <Section radius="0px">
        <Wraper>
          <Row type="flex" justify="space-between">
            <Col md={8} xs={24}></Col>
            <Col md={8} xs={24}>
              <Typography
                align="center"
                text={buyer.buyerName}
                as="h3"
                weight="500"
              />
              <Typography as="p" color="#949AA6" align="center">
                Buyer since
              </Typography>
            </Col>
            <Col md={8} xs={24}>
              <div className="edit--icon_wraper">
                <FormOutlined
                  color="#404E67"
                  onClick={() => openModal("editBuyerModal")}
                />
                <span>Edit</span>
              </div>
            </Col>
          </Row>
        </Wraper>
        <Grid>
          <Statistic data={buyer} />
          <Row type="flex" justify="space-around" gutter={[24, 24]}>
            <Col md={10} xs={22}>
              <Typography {...typoProps}>
                Company Name :
                <span className="themed--color_blue">{buyer.companyName}</span>
              </Typography>
            </Col>
            <Col md={10} xs={22}>
              <Typography {...typoProps}>
                STRN :<span className="themed--color_blue">{buyer.STRN}</span>
              </Typography>
            </Col>
            <Col md={10} xs={22}>
              <Typography {...typoProps}>
                Phone Number :
                <span className="themed--color_blue"> {buyer.phoneNumber}</span>
              </Typography>
            </Col>
            <Col md={10} xs={22}>
              <Typography {...typoProps}>
                NTN :<span className="themed--color_blue">{buyer.NTN} </span>
              </Typography>
            </Col>
            <Col md={22} xs={22}>
              <Typography {...typoProps}>
                Address :
                <span className="themed--color_blue">
                  {buyer.companyAddress}
                </span>
              </Typography>
            </Col>
            <Col md={22} xs={22}>
              <Typography {...typoProps}>
                Godan Address :
                {buyer.GodownAddress.map((godown, index) => (
                  <span className="themed--color_blue">{godown + ","}</span>
                ))}
              </Typography>
            </Col>
            <Col md={22} xs={22}>
              <Typography {...typoProps}>
                Departments :
                <table border="1">
                  <thead>
                    <tr>
                      <td>Department Name</td>
                      <td>Person Name</td>
                      <td>Phone Number </td>
                    </tr>
                  </thead>
                  <thead>
                    {buyer.departmentInfo.map((dept, index) => (
                      <tr className="themed--color_blue">
                        <td>{dept.department_name}</td>
                        <td>{dept.person_name}</td>
                        <td>{dept.phoneNumber}</td>
                      </tr>
                    ))}
                  </thead>
                </table>
              </Typography>
            </Col>
          </Row>
        </Grid>
        <div>
          <BuyerPayments />
        </div>
      </Section>

      {modalState.editBuyerModal && (
        <EditBuyerModal
          editBuyerModal={modalState.editBuyerModal}
          closeModal={closeModal}
          getAllBuyersWithCompanyId={getBuyerWithBuyerId}
          dataToEdit={buyer}
        />
      )}
    </Grid>
  );
};

export default BuyerInner;
